import { LANG_ATTRIBUTE } from '@/utils/constants';

const resolveDateObject = ({ rawVal }: any) => {
  if (!rawVal) return null;

  try {
    const date = new Date(rawVal);
    return {
      formatted: date.toLocaleDateString(LANG_ATTRIBUTE, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }),
      iso: date.toISOString(),
      raw: rawVal,
    };
  } catch (e) {
    return null;
  }
};

export default resolveDateObject;
